import { render, staticRenderFns } from "./Beneficios.vue?vue&type=template&id=1380132f&scoped=true&"
import script from "./Beneficios.vue?vue&type=script&lang=js&"
export * from "./Beneficios.vue?vue&type=script&lang=js&"
import style0 from "./Beneficios.vue?vue&type=style&index=0&id=1380132f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1380132f",
  null
  
)

export default component.exports